import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { copyToWorkspace } from '../../../api/workspaces/copy-to-workspace/copyToWorkspace';

export const useCopyWorkspaceQuizToWorkspace = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: copyToWorkspace,
    onSuccess: () => {
      return queryClient.invalidateQueries(workspaceKeys.all);
    },
  });
};
